class CustomValidation {

    constructor() {
        document.querySelectorAll('[data-custom-validation-messages]').forEach(input => {
            input.addEventListener('invalid', this.onChange.bind(this));
            input.addEventListener('input', this.onChange.bind(this));
        });
    }

    onChange(e) {
        const target = e.currentTarget;

        target.setCustomValidity('');
        if (target.validity.valid) {
            return;
        }

        const messages = $(target).data('custom-validation-messages');

        for (let validityType in messages) {
            if (! messages.hasOwnProperty(validityType)) {
                continue;
            }
            if (target.validity[validityType]) {
                target.setCustomValidity(messages[validityType]);
            }
        }
    }

}
